const usCurrencyFormatter = new Intl.NumberFormat('en-us', {
  style: 'currency',
  currency: 'USD',
  currencySign: 'accounting',
});

export default usCurrencyFormatter.format;
